// extracted by mini-css-extract-plugin
export var button = "_gm-4";
export var hasDarkBackground = "_gm-7";
export var hasLightBackground = "_gm-6";
export var iconWrapper = "_gm-0";
export var large = "_gm-2";
export var medium = "_gm-1";
export var small = "_gm-5";
export var xsmall = "_gm-3";